import AppLogo from "../../assets/icons/people_logo.svg";
import "./Loader.css";

const Loader = () => {
  return (
    <>
      <div className="loader">
        <div className="spinner"></div>
      </div>
      <img src={AppLogo} className="loader-logo" alt="Loading..." />
    </>
  );
};

export default Loader;
